/**
 * Tables Routes
 */
import * as React from 'react';
import {Helmet} from 'react-helmet';
import {Redirect, Route, RouteChildrenProps, Switch} from 'react-router-dom';
// async components
import {AsyncTemplateCollectionsListComponent} from '../components/AsyncComponent/AsyncComponent';
import {useTranslation} from "react-i18next";
import {config} from "../config";

const TemplateCollections: React.FunctionComponent<RouteChildrenProps> = ({match}) => {
    const {t: translate} = useTranslation();
    return (
        <div className="content-wrapper">
            <Helmet>
                <title>{`${config.app.name} - ${translate('suppliers.name')}`}</title>
                <meta name="description" content="Template collections"/>
            </Helmet>
            <Switch>
                <Route exact path={`${match?.url}`} component={AsyncTemplateCollectionsListComponent}/>
                <Redirect exact from={`${match?.url}/`} to={`${match?.url}`}/>
            </Switch>
        </div>
    );
};

export default TemplateCollections;
